export const socialLinks = {
  facebook: "https://www.facebook.com/share/1DqoayrykJ/",
  instagram: "https://www.instagram.com/myhaatworld24?stkn=MXBjamJ0dHBxOG0xYQ==",
  // twitter: "https://twitter.com/",
  // linkedin: "https://linkedin.com/",
  youtube: "https://youtube.com/@myhaatofficial?si=Q1y7b6b9OUGaYLvE",
  whatsapp: "https://wa.me/919046476558",
};
